import React, { useEffect } from "react";
import AOS from "aos";
import SectionTitle from "../SectionTitle/SectionTitle";
import clients from "../../api/clients";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ClientSection = () => {
  useEffect(() => {
    AOS.init({
      offset: 200,
      duration: 1000,
      easing: "ease-in-sine",
      delay: 100,
      once: true,
    });
  }, []);
  const settings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <section className="videos-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12" data-aos="fade-up">
            <SectionTitle title="dipercaya oleh" subtitle="Client Kami" />
          </div>
        </div>
        <div className="row align-items-center">
          <div className="client-slider" data-aos="fade-left">
            <Slider {...settings}>
              {clients.length > 0 &&
                clients.map((client, index) => (
                  <img
                    key={index}
                    src={client.img}
                    alt={client.name}
                    className="img-client"
                    loading="lazy"
                  />
                ))}
            </Slider>
          </div>
        </div>
        <div className="image">
          <div
            className="circle-shape-1"
            data-aos="fade-up"
            data-aos-delay="500"
          ></div>
          <div
            className="circle-shape-2"
            data-aos="fade-up"
            data-aos-delay="1000"
          ></div>
          <div
            className="circle-shape-3"
            data-aos="fade-up"
            data-aos-delay="1500"
          ></div>
          <div
            className="circle-shape-4"
            data-aos="fade-up"
            data-aos-delay="2000"
          ></div>
        </div>
      </div>
    </section>
  );
};

export default ClientSection;
